import React, { useRef, useState, useEffect } from 'react';
import * as Styled from './styles';
import { ASSETS } from '../../utils/config';
import { TextView, Button } from '../../components';
import Icon from 'assets/images/settings/personal-settings2.svg';
import Dropdown from '../Dropdown';
import Input from '../Input';
import { Formik, Field, ErrorMessage, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { object, string } from 'yup';
import { editUserProfileAction } from '../../redux/actions';
import { useSendPhoneOtp, useUserUpdateProfile, useVerifyPhoneOtp } from '../../services/mutations';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from '../../utils';
import { handleFileUpload } from '../../utils/fileUpload';
import CropperProfilePhoto from '../CropperProfilePhoto/CropperProfilePhoto';
import PhoneInput from '../PhoneInput';
import EnterOTP from './EnterOTP';
import { removeHtmlTags } from '../../utils/helpers';

const CenterWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  margin: 0px 2vw;
  padding: 3vw;
`;

const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

const Content = styled.div`
  width: 80%;
  margin-top: 20px;
`;

const InputRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
`;

const Error = styled(TextView)`
  color: ${colors.error};
  position: absolute;
  margin-top: -24px;
`;

const Item = styled.div``;

const ProfileImageContainer = styled.div`
  position: relative;
  cursor: pointer;
  margin-bottom: 16px;
  height: 70px;
  width: 70px;
  border-radius: 35px;

  &:hover > div {
    opacity: 1;
  }
`;

const InnerDiv = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  position: absolute;
  z-index: 10;
`;

const LoadingDiv = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 10;
`;

const EditIconWrapper = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProfileImage = styled.img`
  height: 70px;
  width: 70px;
  cursor: pointer;
  border-radius: 35px;
  border: 0.5px solid #eeeeee;
  margin-right: 5px;
`;

const EditDropdownContent = styled.div`
  position: absolute;
  background-color: white;
  z-index: 100;
  margin-top: 5px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 1px 2px 9px #bbbbbb;
  min-width: 120px;
`;

const EditDropdownItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const genderOptions = [
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
  { label: 'Prefer not to say', value: 'O' },
];

const userSchema = object({
  first_name: string().required('Please enter first name'),
});

export default function PersonalSettings() {
  const { userProfile } = useSelector((state) => state.userProfile);
  const userEdit = useUserUpdateProfile();
  const verifyOTP = useVerifyPhoneOtp();
  const resendOtp = useSendPhoneOtp();
  const dispatch = useDispatch();

  const [editImage, setEditImage] = useState(false);
  const [phone, setPhone] = useState({});
  const [showImageCropper, setShowImageCropper] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState('');
  const dropdownRef = useRef();
  const fileInputRef = useRef();

  // Safely destructure with default values if userProfile is null or undefined
  const {
    first_name = '',
    last_name = '',
    profession = '',
    profile_image = ASSETS.userPlaceholder,
    bio = '',
    email = '',
    phone_number = '',
    country_code = '',
    gender = '',
  } = userProfile || {};

  console.log('KAAAVISHH', userProfile);

  const [image, setImage] = useState(profile_image || ASSETS.userPlaceholder);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setEditImage(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    file && setUploadedFile(URL.createObjectURL(file));
    file && setShowImageCropper(true);
    e.target.value = '';
  };

  const callBackImageCropped = async (imageFile) => {
    setShowImageCropper(false);

    imageFile && setUploadedFile(URL.createObjectURL(imageFile));

    try {
      setLoading(true);
      const { location } = await handleFileUpload(imageFile);
      setImage(location);
      setLoading(false);
    } catch (err) {
      console.error('File upload failed:', err);
      setLoading(false);
    }
  };

  const callBackImageNotCropped = () => setShowImageCropper(false);

  const uploadNewImage = () => {
    fileInputRef.current.click();
    setEditImage(false);
  };

  const removeImage = () => {
    setImage(ASSETS.userPlaceholder);
    setEditImage(false);
  };

  const onEditProfile = (values, { setSubmitting }) => {
    const country_code = values.phone.split(' ')[0];
    const phone_number = values.phone.split(' ')[1]?.replace(/[^\d]/g, '');

    setPhone({ country_code, phone_number });

    const payload = {
      first_name: values?.first_name,
      last_name: values.last_name,
      user_profile: {
        bio: values.bio,
        profession: values.profession,
        profile_image: image,
        gender: values.gender,
        country_code,
        phone_number,
      },
    };

    userEdit.mutate(payload, {
      onSuccess: (response) => {
        // if (
        //   userProfile.phone_number !== phone_number ||
        //   userProfile.country_code !== country_code
        // ) {
        //   setShowOtpModal(true);
        // }
        dispatch(editUserProfileAction(response?.data));
        toast.success('Profile updated successfully!');
        setSubmitting(false);
      },
      onError: (err) => {
        setSubmitting(false);
        toast.error('Some error occurred!');
      },
    });
  };

  const onClickResend = () => {
    resendOtp.mutate(phone, {
      onSuccess: (res) => {
        toast.info('OTP sent successfully!');
      },
      onError: (err) => {
        toast.error(err.response.data.message);
      },
    });
  };

  const onClickVerify = () => {
    if (otp.length == 0) {
      toast.error('Please enter otp');
      return;
    }
    verifyOTP.mutate(
      {
        ...phone,
        otp,
      },
      {
        onSuccess: (res) => {
          toast.success('Phone number verified!');
          closeOtpModal();
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      }
    );
  };

  const closeOtpModal = () => {
    setShowOtpModal(false);
    setOtp('');
  };
  return (
    <CenterWrapper>
      <ContentHeader>
        <HeaderIcon src={Icon} />
        <TextView variant="title">Personal Settings</TextView>
      </ContentHeader>
      <EnterOTP
        open={showOtpModal}
        onClose={closeOtpModal}
        otp={otp}
        setOtp={setOtp}
        onSubmit={onClickVerify}
        onResend={onClickResend}
      />
      <Content>
        {showImageCropper && (
          <CropperProfilePhoto
            ImageURL={uploadedFile}
            callBackImageCropped={callBackImageCropped}
            callBackImageNotCropped={callBackImageNotCropped}
          />
        )}
        <TextView>Your Photo</TextView>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: 'none' }}
          ref={fileInputRef}
          name="imageInput"
          id="imageInput"
        />
        <ProfileImageContainer ref={dropdownRef}>
          <InnerDiv onClick={() => setEditImage(true)}>
            <EditIconWrapper>
              <img src={ASSETS.edit} style={{ width: '15px', height: '15px' }} />
            </EditIconWrapper>
          </InnerDiv>
          {loading && (
            <LoadingDiv>
              <CircularProgress size={16} style={{ color: colors.white }} />
            </LoadingDiv>
          )}
          <ProfileImage src={image ? image : profile_image} alt="profile_image" />
          {editImage ? (
            <EditDropdownContent>
              <EditDropdownItem onClick={uploadNewImage}>
                <img
                  src={ASSETS.upload}
                  style={{
                    marginRight: '8px',
                    height: '15px',
                    width: '15px',
                  }}
                />
                <TextView>Upload New</TextView>
              </EditDropdownItem>
              {image !== ASSETS.userPlaceholder ? (
                <EditDropdownItem onClick={removeImage}>
                  <img
                    src={ASSETS.delete_icon}
                    style={{
                      marginRight: '8px',
                      height: '15px',
                      width: '15px',
                    }}
                  />
                  <TextView style={{ fontSize: '12px' }}>Remove</TextView>
                </EditDropdownItem>
              ) : null}
            </EditDropdownContent>
          ) : null}
        </ProfileImageContainer>

        <Formik
          initialValues={{
            first_name,
            last_name,
            profession,
            bio:removeHtmlTags(bio),
            email,
            phone: `${country_code} ${phone_number}`,
            gender,
          }}
          validationSchema={userSchema}
          onSubmit={onEditProfile}
        >
          {({ isSubmitting, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <InputRow>
                <Item>
                  <Field
                    name="first_name"
                    render={({ field }) => (
                      <Input {...field} label="First Name" placeholder="First Name" />
                    )}
                  />

                  <ErrorMessage name="first_name">
                    {(msg) => <Error variant="tag">*{msg}</Error>}
                  </ErrorMessage>
                </Item>

                <Field
                  name="last_name"
                  render={({ field }) => (
                    <Input {...field} label="Last Name" placeholder="Last Name" />
                  )}
                />
              </InputRow>
              <Field
                name="bio"
                render={({ field }) => (
                  <Input
                    {...field}
                    type="textarea"
                    label="Description here"
                    placeholder="Description here"
                  />
                )}
              />

              {/* <InputRow> */}
              <Field name="email">
                {({ field }) => (
                  <Input {...field} disabled label="Email ID" placeholder="Email ID" />
                )}
              </Field>

              {/* <Field name="phone">
                  {({ field }) => (
                    <PhoneInput {...field} label="Phone Number" disabled />
                  )}
                </Field> */}
              {/* </InputRow> */}
              <InputRow>
                <Field name="gender">
                  {({ field }) => <Dropdown {...field} label={'Gender'} options={genderOptions} />}
                </Field>

                <Field
                  name="profession"
                  render={({ field }) => (
                    <Input {...field} label="Occupation" placeholder="Occupation" />
                  )}
                />
              </InputRow>
              <Button isLoading={isSubmitting} type="submit" style={{ width: 140 }}>
                Save
              </Button>
            </Form>
          )}
        </Formik>
      </Content>
    </CenterWrapper>
  );
}
